export default __webpack_public_path__ + "static/media/dw-telegram.ee79256b.svg";